import posthog from 'posthog-js';
import { useVariables } from './useVariables';

export function useTrack() {
  const { posthogApi, posthogToken } = useVariables();

  const init = () => {
    posthogToken && posthog.init(posthogToken, { api_host: posthogApi });
  };

  const sendEvent = (
    eventName: string,
    properties?: { [key: string]: string | boolean | number }
  ) => {
    posthog.capture(eventName, properties);
  };

  const sendUser = (
    userId: string,
    properties?: { [key: string]: string | boolean | number }
  ) => {
    posthog.identify(userId, properties);
  };

  const register = (properties?: {
    [key: string]: string | boolean | number;
  }) => {
    properties && posthog.register(properties);
  };

  const reset = (flag?: boolean) => {
    posthog.reset(flag);
  };

  const hasFeatureFlag = (flag: string) => {
    const flagEnabled = posthog.isFeatureEnabled(flag);

    return flagEnabled ?? false;
  };

  const getFeaturePayload = (flag: string) => {
    const payload = posthog.getFeatureFlagPayload(flag);
    return payload;
  };

  return {
    init,
    sendEvent,
    sendUser,
    register,
    reset,
    hasFeatureFlag,
    getFeaturePayload,
  };
}
